import React from 'react';
import BillingAddressFields from './BillingAddressFields';
import { Link } from 'react-router-dom';
import { getLanguageCodeFromSession, replaceLoclizationLabel } from '../../../helpers/CommonHelper';

export default function CheckoutBillingInfo({ user, labels = [], billingAddress, sameAsShipping, onSameAsShippingChange, onBillingAddressChange }) {
    const label = (text, id) => labels.length ? replaceLoclizationLabel(labels, text, id) : text;
    const name = [user.FirstName, user.LastName].filter(Boolean).join(' ');
    const locality = [user.CityName, user.StateName, user.PostalCode].filter(Boolean).join(', ');
    return <>
        <section className="checkout-modern__contact" aria-label="Billing contact">
            <span className="checkout-modern__section-label">Billing contact</span>
            <strong>{name || 'Your contact details'}</strong>
            {user.EmailAddress && <span><i className="far fa-envelope" aria-hidden="true" /> {user.EmailAddress}</span>}
            {user.MobileNo && <span><i className="fas fa-phone-alt" aria-hidden="true" /> {user.MobileNo}</span>}
        </section>
        <section className="checkout-modern__address" aria-labelledby="checkout-delivery-heading">
            <div className="checkout-modern__address-heading">
                <span className="checkout-modern__address-icon" aria-hidden="true"><i className="fas fa-map-marker-alt" /></span>
                <h4 id="checkout-delivery-heading">{label('Shipping & delivery address', 'lbl_check_shipadrs')}</h4>
                <Link to={`/${getLanguageCodeFromSession()}/update-profile`} aria-label="Edit shipping and delivery address">Edit</Link>
            </div>
            {user.AddressLineOne ? <address>
                {name && <strong>{name}</strong>}
                <span>{user.AddressLineOne}</span>
                {user.AddressLineTwo && <span>{user.AddressLineTwo}</span>}
                {locality && <span>{locality}</span>}
                {user.CountryName && <span>{user.CountryName}</span>}
                {user.MobileNo && <span className="checkout-modern__delivery-phone">Phone: {user.MobileNo}</span>}
            </address> : <p className="checkout-modern__address-empty">
                Add your delivery address in <Link to={`/${getLanguageCodeFromSession()}/update-profile`}>your profile</Link> before placing an order.
            </p>}
        </section>
        <section className="checkout-modern__address" aria-labelledby="checkout-billing-heading">
            <div className="checkout-modern__address-heading">
                <span className="checkout-modern__address-icon" aria-hidden="true"><i className="fas fa-file-invoice" /></span>
                <h4 id="checkout-billing-heading">Billing address</h4>
            </div>
            <label className="checkout-modern__same-address">
                <input type="checkbox" checked={sameAsShipping} onChange={event => onSameAsShippingChange(event.target.checked)} />
                Same as shipping address
            </label>
            {sameAsShipping && <address className="checkout-modern__billing-preview">{billingAddress}</address>}
            <BillingAddressFields user={user} active={!sameAsShipping} onChange={onBillingAddressChange} />
        </section>
    </>;
}
